import { useLocation } from "react-router-dom";
import qs from "qs";
import dayjs from "dayjs";

export function useDateQueryParams() {
    const location = useLocation();

    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { start_at, end_at } = params;

    const start = () => {
        if (start_at) return start_at;

        return dayjs()
            .startOf("day")
            .unix();
    };

    const end = () => {
        if (end_at) return end_at;

        return dayjs()
            .endOf("day")
            .unix();
    };

    return { start_at: start(), end_at: end() };
}
